import { getPopupContainer } from '@bimser/core';
import { TreeSelect } from 'antd';
import { GetRef } from 'antd/lib';
import * as React from 'react';
import Styles from './assets/style.scss';
import * as BCTreeSelectEntities from './entities';
import { ITreeSelectProps } from './entities';
import { filterReadonlyFields, sortFieldsByType } from './helpers';

Styles;
const treeSelectStyle: React.CSSProperties = { width: '100%' };

const BCTreeSelect = React.memo(
	React.forwardRef<BCTreeSelectRef, ITreeSelectProps>(function BCTreeSelect(props, ref) {
		const treeSelectRef = React.useRef<GetRef<typeof TreeSelect>>();

		React.useImperativeHandle(ref, () => ({
			focus: () => treeSelectRef.current?.focus()
		}));

		const onChange = args => {
			if (!props.readOnly && props.onChange) {
				props.onChange(args);
			}
		};

		return (
			<div style={props.style}>
				<TreeSelect
					ref={treeSelectRef}
					treeData={props.treeData}
					value={props.value}
					onChange={onChange}
					treeCheckable={props.treeCheckable}
					showCheckedStrategy={props.showCheckedStrategy}
					allowClear={props.allowClear}
					size={props.size}
					showSearch={props.showSearch}
					disabled={props.disabled}
					defaultValue={props.defaultValue}
					multiple={props.multiple}
					style={treeSelectStyle}
					treeDefaultExpandAll={props.treeDefaultExpandAll}
					filterTreeNode={props.filterTreeNode}
					treeNodeFilterProp={props.treeNodeFilterProp}
					treeNodeLabelProp={props.treeNodeLabelProp}
					getPopupContainer={props.getPopupContainer || getPopupContainer}
					onSelect={props.onSelect}
					onSearch={props.onSearch}
					className={props.className}
					popupClassName={props.dropdownClassName}
					suffixIcon={props.suffixIcon}
					dropdownRender={props.dropdownRender}
					notFoundContent={props.notFoundContent}
					onTreeExpand={props.onTreeExpand}
					virtual={props.virtual}
					treeDefaultExpandedKeys={props.treeDefaultExpandedKeys}
					dropdownStyle={{
						...props.dropdownStyle,
						backgroundColor: props.style?.backgroundColor
					}}
				/>
			</div>
		);
	})
);
export default BCTreeSelect;

export { BCTreeSelectEntities, ITreeSelectProps, sortFieldsByType, filterReadonlyFields };

export type BCTreeSelectRef = {
	focus: () => void;
};
